import React from 'react';
import { Modal } from 'antd';
import { ReactComponent as CloseSVG } from '../../../img/default-svg/close-black.svg';
import './style.scss';
import Button from "../../Button";
import { identity } from "../../../utils/getIdentity";
import { useTranslation } from "react-i18next";

const DeletePlan = ({ visible, close, removePlan }) => {
  const { t } = useTranslation();
  return (
    <Modal
      width={620}
      title=""
      visible={visible}
      onCancel={close}
      footer={null}
      className={`checkout-modal checkout-modal-${identity}`}
      centered
      closeIcon={<CloseSVG />}
      destroyOnClose
      maskClosable={false}
    >
      <div className={`checkout-modal-content checkout-modal-content-${identity}`}>
        <div className={`checkout-modal-content__title checkout-modal-content__title-${identity}`}>
          {t('admin.delete_plan')}
        </div>
        <div className="checkout-modal-content__body">
          <div className="checkout-modal-content__body--button">
            <Button onClick={() => close()} type="secondary">{t('admin.back')}</Button>
            <Button onClick={removePlan} type="danger">{t('admin.delete')}</Button>
          </div>
        </div>
      </div>
    </Modal>
  )
};

export default DeletePlan;